import React from "react";
import MyRouter from './Router';

import '../res/css/main.css';

const Setup = ()=>{
    return <MyRouter />
}

export default Setup;